<button
  type="button"
  class="btn"
  [ngClass]="classes"
  [class.show-spinner]="showSpinner"
  [disabled]="disabled || showSpinner"
  (click)="onClick()">
  <ng-content></ng-content>
</button>
